import { formatDateTime } from '../../shared/dateTimeFormatting';
import { useDateTimePreferences } from '../../shared/DateTimeProvider';
import React, { useState, useEffect } from 'react';
import { adminApi, AuditEntry } from '../../services/adminApi';

export const AuditLog: React.FC = () => {
  useDateTimePreferences();
  const [entries, setEntries] = useState<AuditEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    action: '',
    fromDate: '',
    toDate: '',
  });

  useEffect(() => {
    loadEntries();
  }, [filters]);

  const loadEntries = async () => {
    setLoading(true);
    try {
      const result = await adminApi.getAuditLog({ ...filters, limit: 100 });
      setEntries(result.entries);
    } catch (err) {
      console.error('Failed to load audit log:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="management-section">
      <h2>Audit Log</h2>
      <div className="filters">
        <select value={filters.action} onChange={(e) => setFilters({ ...filters, action: e.target.value })}>
          <option value="">All Actions</option>
          <option value="TenantCreated">Tenant Created</option>
          <option value="TenantUpdated">Tenant Updated</option>
          <option value="TenantSuspended">Tenant Suspended</option>
          <option value="TenantReactivated">Tenant Reactivated</option>
          <option value="TenantDeleted">Tenant Deleted</option>
          <option value="UserInvited">User Invited</option>
          <option value="UserUpdated">User Updated</option>
          <option value="UserDeleted">User Deleted</option>
          <option value="ApiKeyRegenerated">API Key Regenerated</option>
        </select>
        <input
          type="date"
          value={filters.fromDate}
          onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
          placeholder="From date"
        />
        <input
          type="date"
          value={filters.toDate}
          onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
          placeholder="To date"
        />
        <button className="btn-secondary" onClick={() => setFilters({ action: '', fromDate: '', toDate: '' })}>
          Clear
        </button>
      </div>

      {loading ? (
        <div className="loading">Loading audit log...</div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>Action</th>
              <th>Entity</th>
              <th>User</th>
              <th>Details</th>
              <th>IP Address</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry) => (
              <tr key={entry.id}>
                <td>{formatDateTime(entry.timestamp)}</td>
                <td><span className="action-badge">{entry.action}</span></td>
                <td>{entry.entityType}: {entry.entityId?.substring(0, 8)}...</td>
                <td>{entry.userEmail || entry.userDisplayName || 'System'}</td>
                <td>{entry.details}</td>
                <td>{entry.ipAddress}</td>
              </tr>
            ))}
            {entries.length === 0 && (
              <tr>
                <td colSpan={6} className="empty-row">No audit entries found</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};
